import api from 'service/api-service';
import { saveAuth } from 'service/local-data-provider';
import isEmpty from 'lodash/isEmpty';
import axios from 'axios';

class Repository {
  fetchAutopayBoard = () => {
    const codes = 'auto_pay_street_parking_board';
    return new Promise((resolve, reject) => {
      api
        .boards(codes)
        .then(value => {
          resolve(value.data.data.autoPayStreetParkingBoard);
        })
        .catch(error => reject(error));
    });
  };

  fetchSearchBillBoard = () => {
    const codes = 'search_street_parking_board';
    return new Promise((resolve, reject) => {
      api
        .boards(codes)
        .then(value => {
          resolve(value.data.data.searchStreetParkingBoard);
        })
        .catch(error => reject(error));
    });
  };

  fetchPromotionBoard = () => {
    const codes = 'manage_credit_card_content_ad';
    return new Promise((resolve, reject) => {
      api
        .boards(codes)
        .then(value => {
          resolve(value.data.data.manageCreditCardContentAd);
        })
        .catch(error => reject(error));
    });
  };

  fetchMainPagePromotionBoard = () => {
    const codes = 'main_page_board';
    return new Promise((resolve, reject) => {
      api
        .boards(codes)
        .then(value => {
          let result = value.data.data.mainPageBoard.sort((a, b) => a.sort - b.sort);
          resolve(result);
        })
        .catch(error => reject(error));
    });
  };

  fetchMainPageNotificationBoard = () => {
    const codes = 'main_page_notification_board';
    return new Promise((resolve, reject) => {
      api
        .boards(codes)
        .then(value => {
          let result = value.data.data.mainPageNotificationBoard;
          resolve(result);
        })
        .catch(error => reject(error));
    });
  };

  fetchCoinPageRulesBoard = () => {
    const codes = 'auto_coin_rules_board';
    return new Promise((resolve, reject) => {
      api
        .boards(codes)
        .then(value => {
          resolve(value.data.data.autoCoinRulesBoard);
        })
        .catch(error => reject(error));
    });
  };

  fetchBootstraps = () => {
    return new Promise((resolve, reject) => {
      api
        .bootstraps()
        .then(value => resolve(value.data.data))
        .catch(error => reject(error));
    });
  };

  login = (mobile, code) => {
    return new Promise((resolve, reject) => {
      api
        .auth(mobile, code)
        .then(value => {
          const { data } = value.data;
          saveAuth(data);
          resolve(data);
        })
        .catch(error => reject(error));
    });
  };

  register = (email, displayName, plateNumber, carType) => {
    return new Promise((resolve, reject) => {
      api
        .register(email, displayName, plateNumber, carType)
        .then(value => {
          const { data } = value.data;
          saveAuth(data);
          resolve(data);
        })
        .catch(error => reject(error));
    });
  };

  logout = () => {
    return new Promise((resolve, reject) => {
      api
        .logout()
        .then(() => resolve())
        .catch(error => reject(error));
    });
  };

  changePassword = (oldPassword, newPassword) => {
    return new Promise((resolve, reject) => {
      api
        .changePassword(oldPassword, newPassword)
        .then(value => {
          const { data } = value.data;
          saveAuth(data);
          resolve(data);
        })
        .catch(error => reject(error));
    });
  };

  fetchOtp = mobile => {
    return new Promise((resolve, reject) => {
      api
        .fetchOtp(mobile)
        .then(value => {
          const { data } = value.data;
          resolve(data);
        })
        .catch(error => reject(error));
    });
  };

  fetchUserInfo = () => {
    return new Promise((resolve, reject) => {
      api
        .userInfo()
        .then(value => resolve(value.data.data))
        .catch(error => reject(error));
    });
  };

  updateUserInfo = (
    email = undefined,
    displayName = undefined,
    receipt = undefined,
    enableOnStreetParkingAutoPay = undefined
  ) => {
    return new Promise((resolve, reject) => {
      api
        .updateUserInfo(email, displayName, receipt, enableOnStreetParkingAutoPay)
        .then(value => resolve(value.data.data))
        .catch(error => reject(error));
    });
  };

  fetchStreetParkingBills = (city = undefined, plate = undefined) => {
    return new Promise((resolve, reject) => {
      api
        .fetchStreetParkingBills(city, plate)
        .then(value => resolve(value.data.data))
        .catch(error => reject(error));
    });
  };

  payStreetParkingBills = (city = undefined, codes = undefined, plate = undefined) => {
    return new Promise((resolve, reject) => {
      api
        .payStreetParkingBills(city, codes, plate)
        .then(value => resolve(value.data.data))
        .catch(error => reject(error));
    });
  };

  fetchLicensePlates = () => {
    return new Promise((resolve, reject) => {
      api
        .fetchLicensePlates()
        .then(value => resolve(value.data.data))
        .catch(error => reject(error));
    });
  };

  addLicensePlate = (plateNumber, vehicleType) => {
    return new Promise((resolve, reject) => {
      api
        .addLicensePlate(plateNumber, vehicleType)
        .then(value => resolve(value.data.data))
        .catch(error => reject(error));
    });
  };

  deleteLicensePlate = id => {
    return new Promise((resolve, reject) => {
      api
        .deleteLicensePlate(id)
        .then(value => resolve(value.data.data))
        .catch(error => reject(error));
    });
  };

  bindLicensePlate = id => {
    return new Promise((resolve, reject) => {
      api
        .bindLicensePlate(id)
        .then(value => resolve(value.data.data))
        .catch(error => reject(error));
    });
  };

  modifyLicensePlate = (id, plateNumber, vehicleType) => {
    return new Promise((resolve, reject) => {
      api
        .modifyLicensePlate(id, plateNumber, vehicleType)
        .then(value => resolve(value.data.data))
        .catch(error => reject(error));
    });
  };

  initMochipayValidation = () => {
    return new Promise((resolve, reject) => {
      api
        .initMochipayValidation()
        .then(value => resolve(value.data.data))
        .catch(error => reject(error));
    });
  };

  bindCpcPay = cpcId => {
    return new Promise((resolve, reject) => {
      if (cpcId === '') {
        reject('請先設定你的中油Pay 付款設定');
      } else {
        api
          .bindCpcPay(cpcId)
          .then(value => resolve(value.data.data))
          .catch(error => reject(error));
      }
    });
  };

  getNpcCards = () => {
    return new Promise((resolve, reject) => {
      api
        .getNpcCards()
        .then(value => resolve(value.data.data))
        .catch(error => reject(error));
    });
  };

  bindNpcPay = ({ cardType, enableRedeem = true }) => {
    return new Promise((resolve, reject) => {
      api
        .bindNpcPay({ cardType, enableRedeem })
        .then(value => resolve(value.data.data))
        .catch(error => reject(error));
    });
  };

  enableRedeemDiscount = () => {
    return new Promise((resolve, reject) => {
      api
        .enableRedeemDiscount()
        .then(value => resolve(value.data.data))
        .catch(error => reject(error));
    });
  };

  disableRedeemDiscount = () => {
    return new Promise((resolve, reject) => {
      api
        .disableRedeemDiscount()
        .then(value => resolve(value.data.data))
        .catch(error => reject(error));
    });
  };

  bindMochipayWallet = (token, transactionId) => {
    return new Promise((resolve, reject) => {
      api
        .bindMochipayWallet(token, transactionId)
        .then(value => resolve(value.data.data))
        .catch(error => reject(error));
    });
  };

  deleteCreditCard = () => {
    return new Promise((resolve, reject) => {
      api
        .deleteCreditCard()
        .then(value => resolve(value))
        .catch(error => reject(error));
    });
  };

  fetchDebitAccountTransactions = (id, startAt, endAt, page, totalPage) => {
    return new Promise((resolve, reject) => {
      api
        .fetchDebitAccountTransactions(id, startAt, endAt, page, totalPage)
        .then(value => resolve(value.data))
        .catch(error => reject(error));
    });
  };

  sendDebitAccountTransactionsReport = (id, startAt, endAt) => {
    return new Promise((resolve, reject) => {
      api
        .sendDebitCardReport(id, startAt, endAt)
        .then(() => resolve())
        .catch(error => reject(error));
    });
  };

  fetchTwoFactorAuth = () => {
    return new Promise((resolve, reject) => {
      api
        .fetchTwoFactorAuth()
        .then(value => resolve(value.data.data))
        .catch(error => reject(error));
    });
  };

  enableTwoFactorAuth = totp => {
    return new Promise((resolve, reject) => {
      api
        .enableTwoFactorAuth(totp)
        .then(value => resolve(value.data.data))
        .catch(error => reject(error));
    });
  };

  disableTwoFactorAuth = () => {
    return new Promise((resolve, reject) => {
      api
        .disableTwoFactorAuth()
        .then(value => resolve(value.data.data))
        .catch(error => reject(error));
    });
  };

  fetchOrders = (page, pageSize, transactionTypes = []) => {
    return new Promise((resolve, reject) => {
      api
        .fetchOrders(page, pageSize, transactionTypes.length === 0 ? undefined : transactionTypes.join(','))
        .then(value => resolve(value.data))
        .catch(error => reject(error));
    });
  };

  fetchOrderDetail = url => {
    return new Promise((resolve, reject) => {
      api
        .fetchOrderDetail(url)
        .then(value => resolve(value.data))
        .catch(error => reject(error));
    });
  };

  sendUserReport = (transactionTypes, startAt, endAt, plateNumber) => {
    return new Promise((resolve, reject) => {
      api
        .sendUserReport(transactionTypes, startAt, endAt, plateNumber)
        .then(() => resolve())
        .catch(error => reject(error));
    });
  };

  fetchMochiCoins = ({ state, page }) => {
    return new Promise((resolve, reject) => {
      api
        .fetchMochiCoins({ state, page })
        .then(value => resolve(value.data))
        .catch(error => reject(error));
    });
  };

  fetchParkingRecord = () => {
    return new Promise((resolve, reject) => {
      api
        .fetchParkingRecord()
        .then(value => resolve(value.data.data))
        .catch(error => reject(error));
    });
  };

  parkingRecordCancel = parkingRecordId => {
    return new Promise((resolve, reject) => {
      api
        .parkingRecordCancel(parkingRecordId)
        .then(value => resolve(value.data.data))
        .catch(error => reject(error));
    });
  };

  parkingRecordLeave = parkingRecordId => {
    return new Promise((resolve, reject) => {
      api
        .parkingRecordLeave(parkingRecordId)
        .then(value => resolve(value.data.data))
        .catch(error => reject(error));
    });
  };

  agreeTermsOfTaipeiParkinglotService = () => {
    return new Promise((resolve, reject) => {
      api
        .agreeTermsOfTaipeiParkinglotService()
        .then(value => resolve(value.data.data))
        .catch(error => reject(error));
    });
  };

  updatePushToken = token => {
    return new Promise((resolve, reject) => {
      //如果 token 是 null | undefined | empty string | 'null'，就不要打 api 上傳
      if (isEmpty(token) || token === 'null') {
        resolve();
      } else {
        api
          .updatePushToken(token)
          .then(() => resolve())
          .catch(error => reject(error));
      }
    });
  };

  fetchRefuelingRequestsLatest = () => {
    return new Promise((resolve, reject) => {
      api
        .fetchRefuelingRequestsLatest()
        .then(value => {
          resolve(value.data.data);
        })
        .catch(error => reject(error));
    });
  };

  answerRefuelingRequests = (id, answer) => {
    return new Promise((resolve, reject) => {
      api
        .answerRefuelingRequests(id, answer)
        .then(value => {
          resolve(value.data.data);
        })
        .catch(error => reject(error));
    });
  };

  fetchOilPricing = () => {
    return new Promise((resolve, reject) => {
      axios
        .get('https://mochi-cloud-api.autopass.xyz/v1/gas_pricing')
        .then(value => resolve(value.data.data))
        .catch(err => reject(err));
    });
  };

  fetchOneTimeToken = token => {
    return new Promise((resolve, reject) => {
      api
        .fetchOneTimeToken(token)
        .then(value => {
          resolve(value.data.data);
        })
        .catch(error => reject(error));
    });
  };

  fetchScanPaymentToken = () => {
    return new Promise((resolve, reject) => {
      api
        .fetchScanPaymentToken()
        .then(value => {
          resolve(value.data.data);
        })
        .catch(error => reject(error));
    });
  };

  fetchScanPayPopupBoard = () => {
    const codes = 'barcode_payment_popup_board';
    return new Promise((resolve, reject) => {
      api
        .boards(codes)
        .then(value => {
          resolve(value.data.data.barcodePaymentPopupBoard);
        })
        .catch(error => reject(error));
    });
  };

  fetchScanPayHintBoard = () => {
    const codes = 'barcode_payment_hint_board';
    return new Promise((resolve, reject) => {
      api
        .boards(codes)
        .then(value => {
          resolve(value.data.data.barcodePaymentHintBoard);
        })
        .catch(error => reject(error));
    });
  };
}

export default new Repository();
